import React from "react";
import { useProfile } from "../context/ProfileContext";

const Profile = () => {
  const { profile } = useProfile();

  if (!profile) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-gray-600 text-lg">Loading profile...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-start justify-center py-10">
      <div className="w-full max-w-3xl bg-white rounded-lg shadow-md p-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-8 border-b pb-4">
          My Account
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <ProfileRow label="Full Name" value={profile.fullName || "-"} />
          <ProfileRow
            label="Designation"
            value={profile.role?.name || profile.role?.slug || "-"}
          />
          <ProfileRow
            label="Assigned City"
            value={profile.assignedCity || profile.city || "-"}
          />
          <ProfileRow
            label="Email"
            value={profile.email || profile.emailId || "-"}
          />
          <ProfileRow
            label="Phone"
            value={profile.mobile || profile.phone || "-"}
          />
          {profile.employeeCode && (
            <ProfileRow label="Employee Code" value={profile.employeeCode} />
          )}
        </div>

        {/* Optional: Add edit button or profile picture */}
        {/* <div className="mt-6 text-right">
          <button
            onClick={() => navigate("/admin/edit-profile")}
            className="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2 rounded shadow"
          >
            Edit Profile
          </button>
        </div> */}
      </div>
    </div>
  );
};

const ProfileRow = ({ label, value }) => (
  <div className="flex flex-col">
    <label className="text-sm text-gray-500">{label}</label>
    <div className="mt-1 px-4 py-2 bg-gray-100 text-gray-800 font-medium rounded">
      {value}
    </div>
  </div>
);

export default Profile;
